import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const FLAGS = { JP:'🇯🇵',ES:'🇪🇸',FR:'🇫🇷',CN:'🇨🇳',US:'🇺🇸',KR:'🇰🇷',IT:'🇮🇹',RU:'🇷🇺' };
const CURR_SYM = { USD:'$',EUR:'€',JPY:'¥',CNY:'¥',KRW:'₩',RUB:'₽' };

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [tab, setTab] = useState('buy');
  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title:'', description:'', price:'', currency:'USD', image:'📦', category:'handmade' });
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (tab === 'buy') axios.get('/api/market/orders').then(r => setOrders(r.data)).catch(() => {});
    else { axios.get('/api/market/my-products').then(r => setProducts(r.data)).catch(() => {}); }
  }, [tab]);

  const publish = async () => {
    if (!form.title || !form.price) return setMsg('标题和价格必填');
    try {
      await axios.post('/api/market/products', form);
      setMsg('✅ 商品发布成功！');
      setShowForm(false);
      setForm({ title:'', description:'', price:'', currency:'USD', image:'📦', category:'handmade' });
      const r = await axios.get('/api/market/my-products');
      setProducts(r.data);
      setTimeout(() => setMsg(''), 2000);
    } catch { setMsg('❌ 发布失败'); }
  };

  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>{tab === 'buy' ? '📦 我的订单' : '🏪 我的店铺'}</h2>
        <p className="subtitle">{tab === 'buy' ? '你在全球好物买到的商品' : '管理你的商品和销售'}</p>
      </div>

      {/* Tab 切换 */}
      <div className="discovery-filters">
        <button className={`filter-btn ${tab==='buy'?'active':''}`} onClick={() => setTab('buy')}>📦 买到的</button>
        <button className={`filter-btn ${tab==='sell'?'active':''}`} onClick={() => setTab('sell')}>🏪 我的商品</button>
        <button className="filter-btn" onClick={() => navigate('/marketplace')}>🛒 继续逛</button>
      </div>

      {msg && <div className="alert" style={msg.includes('成功')?{background:'rgba(74,222,128,0.15)',color:'#4ade80',textAlign:'center',border:'1px solid rgba(74,222,128,0.2)'}:{background:'rgba(255,107,107,0.15)',color:'#ff6b6b',textAlign:'center'}}>{msg}</div>}

      {tab === 'buy' && (
        <>
          {orders.length === 0 ? (
            <div className="page-center" style={{minHeight:'40vh'}}><div style={{textAlign:'center',color:'var(--text-dim)'}}><div style={{fontSize:'3rem'}}>📦</div><p>还没有订单</p></div></div>
          ) : (
            <div className="users-grid">
              {orders.map(o => (
                <div key={o.id} className="product-card" style={{opacity: o.status==='paid'?1:0.6}}>
                  <div className="product-image">{o.image || '📦'}</div>
                  <div className="product-info">
                    <div className="product-title">{o.title}</div>
                    <div className="product-meta">
                      <span className="meta-badge">{FLAGS[o.seller_country]||'🌍'} {o.seller_name}</span>
                      <span className="meta-badge" style={{background: o.status==='paid'?'rgba(74,222,128,0.15)':'rgba(255,107,107,0.15)',color: o.status==='paid'?'#4ade80':'#ff6b6b'}}>{o.status === 'paid' ? '✅ 已支付' : o.status}</span>
                    </div>
                    <div className="product-price">{CURR_SYM[o.currency]||'$'}{o.total?.toLocaleString?.() || o.price}</div>
                    <div className="product-seller">🕐 {new Date(o.created_at).toLocaleString('zh-CN')}</div>
                    {o.fromCountry && <div className="product-seller">🏭 {o.warehouseName || o.fromCountry} → 📍 {o.shipping_address}</div>}
                    {o.estimatedDays && <div className="product-seller" style={{color:'var(--accent2)'}}>🚚 预计 {o.estimatedDays} 天到达</div>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {tab === 'sell' && (
        <>
          <div style={{textAlign:'center',marginBottom:20}}>
            <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
              {showForm ? '✕ 收起' : '➕ 发布新商品'}
            </button>
          </div>

          {showForm && (
            <div className="card form-card" style={{margin:'0 auto 24px',maxWidth:500}}>
              <h3>📝 发布商品</h3>
              <div className="field"><label>商品名</label><input value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="给商品取个名字" /></div>
              <div className="field"><label>描述</label><textarea value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} rows={2} placeholder="描述你的商品..." /></div>
              <div style={{display:'flex',gap:10}}>
                <div className="field" style={{flex:1}}><label>价格</label><input type="number" value={form.price} onChange={e=>setForm(f=>({...f,price:e.target.value}))} placeholder="0" /></div>
                <div className="field" style={{width:120}}><label>货币</label><select value={form.currency} onChange={e=>setForm(f=>({...f,currency:e.target.value}))}><option value="USD">$ USD</option><option value="EUR">€ EUR</option><option value="JPY">¥ JPY</option><option value="CNY">¥ CNY</option><option value="KRW">₩ KRW</option><option value="RUB">₽ RUB</option></select></div>
              </div>
              <div className="field"><label>Emoji</label><input value={form.image} onChange={e=>setForm(f=>({...f,image:e.target.value}))} placeholder="📦" /></div>
              <div className="field"><label>类别</label><select value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))}><option value="handmade">🎨 手作</option><option value="food">🍔 美食</option><option value="fashion">👗 时尚</option><option value="art">🖼️ 艺术</option><option value="beauty">🧴 美妆</option><option value="entertainment">🎬 娱乐</option><option value="outdoor">🏔️ 户外</option></select></div>
              <button className="btn btn-primary btn-block" onClick={publish}>🚀 发布</button>
            </div>
          )}

          {products.length === 0 && !showForm ? (
            <div className="page-center" style={{minHeight:'40vh'}}><div style={{textAlign:'center',color:'var(--text-dim)'}}><div style={{fontSize:'3rem'}}>🏪</div><p>还没有上架商品</p></div></div>
          ) : (
            <div className="users-grid">
              {products.map(p => (
                <div key={p.id} className="product-card">
                  <div className="product-image">{p.image || '📦'}</div>
                  <div className="product-info">
                    <div className="product-title">{p.title}</div>
                    <div className="product-desc">{p.description}</div>
                    <div className="product-meta">
                      <span className="meta-badge" style={p.status==='active'?{background:'rgba(74,222,128,0.15)',color:'#4ade80'}:{background:'rgba(255,107,107,0.15)',color:'#ff6b6b'}}>{p.status === 'active' ? '🟢 在售' : '🔴 已售'}</span>
                      <span className="meta-badge">{p.category}</span>
                    </div>
                    <div className="product-price">{CURR_SYM[p.currency]||'$'}{p.price?.toLocaleString?.() || p.price}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
